import { WeatherRainyIcon } from './WeatherRainyIcon';

/**
 * author: Austin Andrews
 * id 45EF5E01-7499-4964-A897-5602F45A822E
 * name weather-rainy
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-rainy.svg
 * tags
 * - Weather 
 * - Agriculture 
 */
export const WeatherSpittingIcon = WeatherRainyIcon;
export default WeatherSpittingIcon